import SEOMeta from '@/components/feature/SEOMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteInfo } from '@/mocks/siteInfo';

const testimonials = [
  {
    name: '漫迷小王',
    role: '韩漫爱好者',
    content: '韩漫导航是我每天必用的网站，找韩漫平台太方便了！之前总是记不住各种韩漫网址，现在在这里一键就能跳转，省时又省力。',
    rating: 5,
  },
  {
    name: '漫画达人李',
    role: '资深漫迷',
    content: '分类很清晰，免费和付费分得很清楚。推荐平台质量也很高，我发现了好几个之前不知道的优质韩漫网站，真心推荐给所有韩漫爱好者。',
    rating: 5,
  },
  {
    name: '小陈同学',
    role: '大学生漫迷',
    content: '作为一个学生党，最关心的就是免费韩漫资源。韩漫导航把免费平台整理得很全，帮我省了不少找资源的时间，点赞！',
    rating: 5,
  },
  {
    name: '老张追漫',
    role: '韩漫平台站长',
    content: '我们平台入驻韩漫导航后，流量提升很明显。这个导航站做得很专业，收录标准严格，对优质平台来说是很好的曝光渠道。',
    rating: 4,
  },
  {
    name: '甜甜圈',
    role: '韩漫博主',
    content: '作为韩漫领域的自媒体博主，韩漫导航是我重要的信息源。不仅平台收录全面，文章内容也很有深度，经常给我创作灵感。',
    rating: 5,
  },
  {
    name: '追漫少年',
    role: '高中生漫迷',
    content: '界面简洁好看，没有乱七八糟的广告，使用体验很好。最喜欢的是分类筛选功能，想找什么类型的平台一目了然。',
    rating: 5,
  },
];

export default function AboutPage() {
  const orgSchema = {
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    foundingDate: siteInfo.foundedYear,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: siteInfo.email,
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <main>
      <SEOMeta
        title={`关于我们 - ${siteInfo.name} | 韩漫平台导航`}
        description={`了解${siteInfo.name}的品牌故事与发展历程。${siteInfo.description}我们致力于为韩漫爱好者提供最全面、最便捷的韩漫平台导航服务。`}
        keywords="韩漫导航关于我们,韩漫网站导航,韩漫平台,联系我们"
        canonicalUrl="https://hanman.site/about"
      />
      <SchemaOrg type="Organization" data={orgSchema} />

      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: '关于我们' },
        ]}
      />

      {/* Brand Intro */}
      <section className="w-full px-4 md:px-6 py-6 md:py-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
            关于 {siteInfo.name}
          </h1>

          <div className="bg-white rounded-2xl p-6 md:p-10">
            <p className="text-foreground-700 leading-8 mb-6">
              <strong className="text-foreground-950">韩漫导航</strong>成立于{siteInfo.foundedYear}年，是专注于韩漫漫画网址导航的聚合平台。我们致力于为韩漫爱好者提供一站式的韩漫平台入口导航服务，帮助漫迷快速找到心仪的韩漫阅读平台。
            </p>
            <p className="text-foreground-700 leading-8 mb-6">
              经过多年的积累与发展，我们已收录超过<strong className="text-primary-600">{siteInfo.stats.platforms}</strong>个优质韩漫平台，服务了<strong className="text-primary-600">{siteInfo.stats.users}</strong>多名韩漫爱好者，累计发布<strong className="text-primary-600">{siteInfo.stats.articles}</strong>篇优质韩漫资讯与攻略文章。
            </p>

            <h2 className="font-heading text-lg font-bold text-foreground-950 mt-10 mb-4">我们的使命</h2>
            <p className="text-foreground-700 leading-8 mb-6">
              让每一位韩漫爱好者都能轻松找到最适合自己的韩漫阅读平台。无论是追求免费资源、高清画质，还是社区交流，我们都能帮你快速定位目标。
            </p>

            <h2 className="font-heading text-lg font-bold text-foreground-950 mt-10 mb-4">为什么选择我们</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-check-double-line text-accent-700 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">全面收录</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">持续收录最新、最优质的韩漫平台，覆盖各类需求</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-accent-700 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">严格筛选</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">每个收录平台都经过人工审核，确保质量可靠</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-flashlight-line text-accent-700 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">快捷导航</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">清晰的分类和搜索功能，让你秒速找到目标平台</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-article-line text-accent-700 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">深度内容</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">提供平台测评、追漫攻略等优质原创内容</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-6 py-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
            {[
              { value: siteInfo.stats.platforms, label: '收录平台' },
              { value: siteInfo.stats.users, label: '漫迷用户' },
              { value: siteInfo.stats.articles, label: '攻略文章' },
              { value: siteInfo.stats.categories, label: '内容分类' },
            ].map((stat) => (
              <div key={stat.label} className="bg-white rounded-xl p-6">
                <strong className="font-heading text-3xl font-bold text-primary-500 block mb-1">
                  {stat.value}
                </strong>
                <span className="text-sm text-foreground-600">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
            用户好评
          </h2>
          <p className="text-foreground-600 text-sm text-center mb-10">
            来自韩漫爱好者的真实评价
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {testimonials.map((t, idx) => (
              <div key={idx} className="bg-white rounded-xl p-5">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-xs ${i < t.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;{t.content}&rdquo;
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-full">
                    <i className="ri-user-line text-primary-600 text-sm"></i>
                  </div>
                  <div>
                    <span className="text-xs font-medium text-foreground-900 block">{t.name}</span>
                    <span className="text-xs text-foreground-500">{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm mb-8">
            有韩漫平台收录需求或任何问题，欢迎随时联系我们
          </p>

          <div className="bg-white rounded-2xl p-8 md:p-10">
            <div className="flex flex-col items-center gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl">
                  <i className="ri-mail-line text-primary-600 text-xl"></i>
                </div>
                <div className="text-left">
                  <span className="text-xs text-foreground-500 block">电子邮箱</span>
                  <strong className="text-foreground-900 text-sm">{siteInfo.email}</strong>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl">
                  <i className="ri-global-line text-accent-700 text-xl"></i>
                </div>
                <div className="text-left">
                  <span className="text-xs text-foreground-500 block">官方网站</span>
                  <strong className="text-foreground-900 text-sm">{siteInfo.url}</strong>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-xl">
                  <i className="ri-time-line text-secondary-700 text-xl"></i>
                </div>
                <div className="text-left">
                  <span className="text-xs text-foreground-500 block">成立时间</span>
                  <strong className="text-foreground-900 text-sm">{siteInfo.foundedYear}年</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}